import React from "react";
import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { estimateSectionHeaderProps } from "../../utils/estimateSectionHeaderStyles";
import {
  DELETE_COLUMN_WIDTH,
  OPTION_ROW_OUTER_GAP,
} from "../constants/deliveryOptionRowLayout";

interface DeliveryOptionsTableHeaderProps {
  showDeleteColumn: boolean;
}

export const DeliveryOptionsTableHeader: React.FC<
  DeliveryOptionsTableHeaderProps
> = ({ showDeleteColumn }) => (
  <HStack spacing={OPTION_ROW_OUTER_GAP} px={0} mb={1} align="flex-end">
    <HStack spacing={4} flex={1} align="flex-end">
      <Box w="220px">
        <Text {...estimateSectionHeaderProps}>Customer Promise Time</Text>
      </Box>
      <Flex flex="1" />
      <Text
        {...estimateSectionHeaderProps}
        minW="132px"
        textAlign="right"
        whiteSpace="nowrap"
      >
        Delivery Charge
      </Text>
    </HStack>
    {showDeleteColumn && <Box w={DELETE_COLUMN_WIDTH} flexShrink={0} />}
  </HStack>
);
